module.exports = "/_next/static/images/DataDrivenReport@2x-0ce63e100baee6fe98cbfc8b73d2a931.png";